module.exports = {
  "version": "0.23.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 235
// module chunks = 0